import { render, staticRenderFns } from "./QuestionLong.vue?vue&type=template&id=659d3a99&scoped=true&"
import script from "./QuestionLong.vue?vue&type=script&lang=js&"
export * from "./QuestionLong.vue?vue&type=script&lang=js&"
import style0 from "./QuestionLong.vue?vue&type=style&index=0&id=659d3a99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659d3a99",
  null
  
)

export default component.exports